import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './About.css';
import aboutImage from '../media/about.jpeg';
import {
    FaReact, FaGitAlt, FaDocker, FaCode,
    FaDatabase, FaPalette, FaRocket, FaLightbulb,
    FaHtml5, FaCss3Alt, FaLinux, FaWindows, FaTerminal
} from 'react-icons/fa';
import {
    SiJavascript, SiDotnet, SiGnubash
} from 'react-icons/si';

const About = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const skills = {
        frontend: [
            { name: 'HTML5', icon: <FaHtml5 />, level: 95 },
            { name: 'CSS3', icon: <FaCss3Alt />, level: 90 },
            { name: 'JavaScript', icon: <SiJavascript />, level: 85 },
            { name: 'React', icon: <FaReact />, level: 75 },
        ],
        backend: [
            { name: 'C#', icon: <FaCode />, level: 90 },
            { name: 'ASP.NET Core', icon: <SiDotnet />, level: 85 },
            { name: 'EF Core', icon: <FaDatabase />, level: 85 },
            { name: 'SQL Server', icon: <FaDatabase />, level: 85 },
        ],
        tools: [
            { name: 'Git', icon: <FaGitAlt />, level: 90 },
            { name: 'Docker', icon: <FaDocker />, level: 75 },
            { name: 'Linux', icon: <FaLinux />, level: 80 },
            { name: 'Visual Studio', icon: <FaWindows />, level: 90 },
        ],
    };

    const highlights = [
        {
            icon: <FaCode />,
            title: 'Clean Code',
            description: 'Writing maintainable, scalable, and well-documented code',
        },
        {
            icon: <FaPalette />,
            title: 'UI/UX Design',
            description: 'Creating beautiful, intuitive user experiences',
        },
        {
            icon: <FaRocket />,
            title: 'Performance',
            description: 'Optimizing applications for speed and efficiency',
        },
        {
            icon: <FaLightbulb />,
            title: 'Problem Solving',
            description: 'Finding creative solutions to complex challenges',
        },
    ];

    return (
        <section className="about" id="about">
            <div className="about-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container about-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        About <span className="gradient-text">Me</span>
                    </h2>
                    <p className="section-subtitle">
                        Get to know more about my skills, experience, and what drives me
                    </p>
                </div>

                <div className="about-content">
                    {/* Introduction */}
                    <div className="about-intro" data-aos="fade-right">
                        {/* About Image */}
                        <div className="about-image-container">
                            <img src={aboutImage} alt="About Me" className="about-image" />
                            <div className="image-border"></div>
                        </div>
                        <h3 className="intro-title">Hi, I'm a Full Stack Developer</h3>
                        <p className="intro-text">
                            Third-year Computer Science student with hands-on experience in Full Stack .NET development and
                            Linux system administration. Completed 360+ hours of intensive technical training through ITI, NTI,
                            and IEEE programs. Proficient in ASP.NET Core MVC, Entity Framework Core, SQL Server, and
                            Red Hat Linux.
                        </p>
                        <p className="intro-text">
                            Developed multiple web applications implementing clean architecture patterns and
                            best practices. Aspiring to combine development expertise with DevOps practices to build scalable and
                            efficient solutions.
                        </p>


                    </div>

                    {/* Highlights Grid */}
                    <div className="highlights-grid" data-aos="fade-left" data-aos-delay="200">
                        {highlights.map((highlight, index) => (
                            <div
                                className="highlight-card"
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={300 + index * 100}
                            >
                                <div className="highlight-icon">{highlight.icon}</div>
                                <h4 className="highlight-title">{highlight.title}</h4>
                                <p className="highlight-description">{highlight.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Skills Section */}
                <div className="skills-section">
                    <h3 className="skills-title" data-aos="fade-up">Technical Skills</h3>

                    <div className="skills-category" data-aos="fade-up" data-aos-delay="100">
                        <h4 className="category-title">Frontend Development</h4>
                        <div className="skills-grid">
                            {skills.frontend.map((skill, index) => (
                                <div className="skill-card" key={index}>
                                    <div className="skill-icon">{skill.icon}</div>
                                    <span className="skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="skills-category" data-aos="fade-up" data-aos-delay="200">
                        <h4 className="category-title">Backend Development</h4>
                        <div className="skills-grid">
                            {skills.backend.map((skill, index) => (
                                <div className="skill-card" key={index}>
                                    <div className="skill-icon">{skill.icon}</div>
                                    <span className="skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="skills-category" data-aos="fade-up" data-aos-delay="300">
                        <h4 className="category-title">Tools & Technologies</h4>
                        <div className="skills-grid">
                            {skills.tools.map((skill, index) => (
                                <div className="skill-card" key={index}>
                                    <div className="skill-icon">{skill.icon}</div>
                                    <span className="skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
